// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"743736bb","381":"3cc49950"}[chunkId] + ".chunk.css";
};